var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4635 2.6416L27.9834 8.12168C27.158 8.94707 26.2852 10.0322 26 11.0834C25.7149 10.0322 25.2472 8.9471 24.4218 8.12172L18.9418 2.64164C16.4196 0.1195 12.3304 0.1195 9.80829 2.64164C7.53328 4.91664 7.40212 8.55847 9.23129 11.0833L26 11.0834L6.62502 11.0834C3.05818 11.0834 0.166687 13.9749 0.166687 17.5417C0.166687 19.3019 0.870853 20.8976 2.01285 22.0625H25.9875L26 22.0625L26.0125 22.0625H49.9872C51.1292 20.8976 51.8334 19.3019 51.8334 17.5417C51.8334 13.9749 48.9419 11.0834 45.375 11.0834L42.597 11.0834L43.2657 11.0833C45.0949 8.55847 44.8719 4.91661 42.5969 2.6416C40.0748 0.119466 35.9856 0.119466 33.4635 2.6416Z",
    fill: "#232222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70106 26.1587L2.69306 25.8457H24.0625V49.7415H22.125C16.1066 49.7415 13.0974 49.7415 10.7237 48.7115C7.55876 47.3381 5.04422 44.7038 3.73326 41.3882C2.75012 38.9016 2.75012 35.7479 2.75012 29.444C2.75012 28.0622 2.72341 27.026 2.70106 26.1587Z",
    fill: "#232222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2764 48.7115C38.9027 49.7415 35.8934 49.7415 29.875 49.7415H27.9375V25.8457H49.2354C49.25 26.7761 49.25 27.8921 49.25 29.4439C49.25 35.7489 49.25 38.9014 48.2668 41.3882C46.9558 44.7038 44.4413 47.3381 41.2764 48.7115Z",
    fill: "#232222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.d168ecd6e4ad4688498079135046ed16.svg";
export { ForwardRef as ReactComponent };